import React from "react";
export var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["PDF_GENERATION_FAILED"] = "P\u0159i generov\u00E1n\u00ED se vyskytla neo\u010Dek\u00E1van\u00E1 chyba.<br> Pros\u00EDm zkuste to znovu.";
    ErrorMessages["INVALID_PARAMS"] = "YEAR";
    ErrorMessages["INVALID_PROJECTS"] = "YEAR";
    ErrorMessages["INVALID_NAME"] = "YEAR";
    ErrorMessages["INVALID_GOAL"] = "YEAR";
    ErrorMessages["INVALID_DATE"] = "YEAR";
})(ErrorMessages || (ErrorMessages = {}));
export var errorMessage = function (errorCode) {
    switch (errorCode) {
        case "INVALID_PROGRAM":
            return (React.createElement(React.Fragment, null,
                "P\u0159i v\u00FDb\u011Bru programu nastala chyba.",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        case "INVALID_FORMAT":
            return (React.createElement(React.Fragment, null,
                "P\u0159i v\u00FDb\u011Bru formatu nastala chyba.",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        case "INVALID_NAME":
            return (React.createElement(React.Fragment, null,
                "P\u0159i vkl\u00E1d\u00E1n\u00ED n\u00E1zvu projektu nastala chyba.",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        case "INVALID_GOAL":
            return (React.createElement(React.Fragment, null,
                "P\u0159i vkl\u00E1d\u00E1n\u00ED c\u00EDle projektu nastala chyba.",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        case "INVALID_DATE":
            return (React.createElement(React.Fragment, null,
                "P\u0159i vkl\u00E1d\u00E1n\u00ED data projektu nastala chyba.",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        case "INVALID_YEAR":
            return (React.createElement(React.Fragment, null,
                "P\u0159i vkl\u00E1d\u00E1n\u00ED roku projektu nastala chyba.",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        case "RECAPTCHA_VERIFICATION_FAILED":
            return (React.createElement(React.Fragment, null, "Opravdu nejste robot?"));
        case "IMAGE_RESOLUTION_IS_TO_BIG":
            return (React.createElement(React.Fragment, null,
                "Vlo\u017Een\u00E9 logo se nepoda\u0159ilo zpracovat.",
                React.createElement("br", null),
                " Vlo\u017Ete logo s men\u0161\u00EDm rozli\u0161en\u00EDm"));
        case "INVALID_PROJECTS":
            return (React.createElement(React.Fragment, null,
                "Zadali jste nespr\u00E1vn\u00FD po\u010Det program\u016F.",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        case "INVALID_SPONSOR":
            return (React.createElement(React.Fragment, null,
                "Zadali jste nespr\u00E1vn\u00E9 financov\u00E1n\u00ED z Evropsk\u00E9 unie.",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        case "INVALID_PROGRAM_SUPPORT":
            return (React.createElement(React.Fragment, null,
                "Zadali jste nespr\u00E1vni program podpory",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        case "INVALID_DEBET":
            return (React.createElement(React.Fragment, null,
                "Hodnoty financov\u00E1n\u00ED projektu nejsou spr\u00E1vn\u00E9",
                React.createElement("br", null),
                " Pros\u00EDm zkuste zm\u011Bnit toto nastaven\u00ED."));
        default:
        case "PDF_GENERATION_FAILED":
            return (React.createElement(React.Fragment, null,
                "P\u0159i generov\u00E1n\u00ED se vyskytla neo\u010Dek\u00E1van\u00E1 chyba.",
                React.createElement("br", null),
                " Pros\u00EDm zkuste to znovu."));
    }
};
